import { render, staticRenderFns } from "./BDXWizardCurrencies.vue?vue&type=template&id=c5c5e228"
import script from "./BDXWizardCurrencies.vue?vue&type=script&lang=js"
export * from "./BDXWizardCurrencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports